import { API_BASE_URL } from "../apiConfig";
import React, { useEffect, useState } from "react";
import "./RecyclingDashboard.css";

const itemIcons = {
  Plastic: "PL",
  Cardboard: "CB",
  Paper: "PA",
  "Metal Can": "MC",
  Glass: "GL",
};

const getIcon = (name) => itemIcons[name] || "RC";

const formatDate = (d) =>
  new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

const isToday = (date) => new Date(date).toDateString() === new Date().toDateString();

const RecyclingDetections = () => {
  const [detectedItems, setDetectedItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  const showToast = (msg, type = "success") => {
    setToast({ msg, type });
    setTimeout(() => setToast(null), 3000);
  };

  useEffect(() => {
    const fetchDetectedItems = async () => {
      try {
        setLoading(true);
        const res = await fetch(`${API_BASE_URL}/api/recycling/all-detected`);
        const data = await res.json();
        setDetectedItems(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Error fetching detected items:", err);
        showToast("Failed to load detected items", "error");
      } finally {
        setLoading(false);
      }
    };

    fetchDetectedItems();
  }, []);

  const todaysItems = detectedItems.filter((item) => isToday(item.createdAt));

  return (
    <div className="rcd-page">
      {toast && <div className={`rcd-toast rcd-toast-${toast.type}`}>{toast.msg}</div>}

      <div className="rcd-topbar">
        <div>
          <h1>Detections</h1>
          <p>Recyclable items detected from complaint images.</p>
        </div>
      </div>

      {loading ? (
        <div className="rcd-loading">Loading detected items...</div>
      ) : (
        <div className="rcd-panel">
          <div className="rcd-panel-header green-header">
            <span>ID</span>
            <h2>Items Detected Today</h2>
            <span className="rcd-badge green-badge">{todaysItems.length}</span>
          </div>

          {todaysItems.length === 0 ? (
            <div className="rcd-empty">
              <span>--</span>
              <p>No recyclable items detected today.</p>
            </div>
          ) : (
            <div className="rcd-detected-list">
              {todaysItems.map((item, index) => (
                <div key={`${item._id}-${index}`} className="rcd-detected-card">
                  <div className="rcd-detected-icon">{getIcon(item.className)}</div>
                  <div className="rcd-detected-info">
                    <span className="rcd-detected-name">{item.className}</span>
                    <span className="rcd-detected-conf">
                      Confidence: {Math.round(Number(item.confidence || 0) * 100)}%
                    </span>
                    {item.description && (
                      <span className="rcd-detected-desc" title={item.description}>
                        "{item.description.substring(0, 50)}..."
                      </span>
                    )}
                    <span className="rcd-detected-date">{formatDate(item.createdAt)}</span>
                  </div>
                  <div className="rcd-detected-loc">
                    {item.location?.lat?.toFixed(3)}, {item.location?.lng?.toFixed(3)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RecyclingDetections;
